export class UnitEditModel {
    public id: number;
    public companyId: number;
    public facilityId: number;
    public name: string;
    public status: number;
}
